import articleTypeValidator from './articleTypeValidator';

export default articleTypeValidator;
